import CalculosDeDepreciacionConstant from 'constants/tiposDeCalculoDeDepreciacion'
import ModalidadCalculosDeDepreciacionConstant from 'constants/modalidadDeCalculoDeDepreciacion'

const getValoresIniciales = input => {
  return {
    _idDepartamento: input._idDepartamento || '',
    _idProvincia: input._idProvincia || '',
    _idDistrito: input._idDistrito || '',
    flag1500Uit: input.flag1500Uit || false,
    flagAltoBajo: input.flagAltoBajo || false,
    flagPaseConsumos: input.flagPaseConsumos || false,
    cuentaContableGananciaTC: input.cuentaContableGananciaTC || '',
    descripcionCuentaContableGananciaTC: input.descripcionCuentaContableGananciaTC || '',
    cuentaContableICBPER: input.cuentaContableICBPER || '',
    cuentaCorrienteDetraccion: input.cuentaCorrienteDetraccion || '',
    descripcionCuentaContableICBPER: input.descripcionCuentaContableICBPER || '',
    cuentaContableIGVCompra1: input.cuentaContableIGVCompra1 || '',
    descripcionCuentaContableIGVCompra1: input.descripcionCuentaContableIGVCompra1 || '',
    cuentaContableIGVCompra2: input.cuentaContableIGVCompra2 || '',
    descripcionCuentaContableIGVCompra2: input.descripcionCuentaContableIGVCompra2 || '',
    cuentaContableIGVCompra4016: input.cuentaContableIGVCompra4016 || '',
    descripcionCuentaContableIGVCompra4016: input.descripcionCuentaContableIGVCompra4016 || '',
    cuentaContableIGVCompra4017: input.cuentaContableIGVCompra4017 || '',
    descripcionCuentaContableIGVCompra4017: input.descripcionCuentaContableIGVCompra4017 || '',
    cuentaContableIGVVenta: input.cuentaContableIGVVenta || '',
    descripcionCuentaContableIGVVenta: input.descripcionCuentaContableIGVVenta || '',
    cuentaContableISC: input.cuentaContableISC || '',
    descripcionCuentaContableISC: input.descripcionCuentaContableISC || '',
    cuentaContableDetraccion: input.cuentaContableDetraccion || '',
    cuentaContableExistenciasPorRecibir: input.cuentaContableExistenciasPorRecibir || '',
    cuentaContableObraEnCurso: input.cuentaContableObraEnCurso || '',
    descripcionCuentaContableObraEnCurso: input.descripcionCuentaContableObraEnCurso || '',
    descripcionCuentaContableExistenciasPorRecibir: input.descripcionCuentaContableExistenciasPorRecibir || '',
    descripcionCuentaContableDetraccion: input.descripcionCuentaContableDetraccion || '',
    cuentaContablePercepcionIGV: input.cuentaContablePercepcionIGV || '',
    descripcionCuentaContablePercepcionIGV: input.descripcionCuentaContablePercepcionIGV || '',
    cuentaContablePerdidaTC: input.cuentaContablePerdidaTC || '',
    descripcionCuentaContablePerdidaTC: input.descripcionCuentaContablePerdidaTC || '',
    cuentaContableResultadoEjercicio: input.cuentaContableResultadoEjercicio || '',
    descripcionCuentaContableResultadoEjercicio: input.descripcionCuentaContableResultadoEjercicio || '',
    cuentaContableResultadoGananciaEjercicio: input.cuentaContableResultadoGananciaEjercicio || '',
    descripcionCuentaContableResultadoGananciaEjercicio:
      input.descripcionCuentaContableResultadoGananciaEjercicio || '',
    cuentaContableResultadoPerdidaEjercicio: input.cuentaContableResultadoPerdidaEjercicio || '',
    descripcionCuentaContableResultadoPerdidaEjercicio: input.descripcionCuentaContableResultadoPerdidaEjercicio || '',
    cuentaContableRetencionIGV: input.cuentaContableRetencionIGV || '',
    descripcionCuentaContableRetencionIGV: input.descripcionCuentaContableRetencionIGV || '',
    cuentaContableRetencionRH: input.cuentaContableRetencionRH || '',
    descripcionCuentaContableRetencionRH: input.descripcionCuentaContableRetencionRH || '',
    calculoDeDepreciacion: input.calculoDeDepreciacion || CalculosDeDepreciacionConstant.NINGUNO,
    modalidadCalculoDeDepreciacion:
      input.modalidadCalculoDeDepreciacion || ModalidadCalculosDeDepreciacionConstant._CLASE9_CC,
    defectoAfectacionCompras: input.defectoAfectacionCompras || '',
    defectoAfectacionVentas: input.defectoAfectacionVentas || '',
    cuentaContableClase7: input.cuentaContableClase7 || '',
    cuentaContableClase7Info: input.cuentaContableClase7Info || '',
    ruc: input.ruc || '',
    razonSocial: input.razonSocial || '',
    idCLienteSIRE: input.idCLienteSIRE || '',
    claveCLienteSIRE: input.claveCLienteSIRE || '',
    usuarioSOL: input.usuarioSOL || '',
    claveSOL: input.claveSOL || ''
  }
}

export default getValoresIniciales
